// extracted by mini-css-extract-plugin
export default {"gallery":"c-l_ep","gallery__thumbs":"c-l_eq"};